import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';

export const addRoleSchema = z.object({
  role: z
    .string()
    .trim()
    .nonempty(VALIDATION_MESSAGES.roleName.required)
    .min(2, VALIDATION_MESSAGES.roleName.min)
    .max(50, VALIDATION_MESSAGES.roleName.max),

  description: z
    .string()
    .trim()
    .max(250, VALIDATION_MESSAGES.roleDescription.max)
    .optional(),

  permissions: z.record(z.string(), z.boolean().optional()),
});

export type TAddRoleFormValues = z.infer<typeof addRoleSchema>;
export type TEditRoleFormValues = z.infer<typeof editRoleSchema>;

export const editRoleSchema = addRoleSchema.extend({
  role: z.string().optional(),
});
